import { render, staticRenderFns } from "./DetailedInfo.vue?vue&type=template&id=1cb43544&scoped=true"
import script from "./DetailedInfo.vue?vue&type=script&lang=js"
export * from "./DetailedInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailedInfo.vue?vue&type=style&index=0&id=1cb43544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb43544",
  null
  
)

export default component.exports